/**
 * loadingKeys is a list of unique keys of currently loading information.
 */
export interface State {
    loadingKeys: string[];
}

export const initialState: State = {
    loadingKeys: []
};
